import { render } from "./EditPKCModal.vue?vue&type=template&id=8c0671f4&scoped=true"
import script from "./EditPKCModal.vue?vue&type=script&lang=js"
export * from "./EditPKCModal.vue?vue&type=script&lang=js"

import "./EditPKCModal.vue?vue&type=style&index=0&id=8c0671f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0671f4"]])

export default __exports__